import ApiRequest from "./actions/ApiRequest";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC0rmtrz4ePxg_uKySO7-KOgjR2T1vybs8",
  authDomain: "phoneplay-8d087.firebaseapp.com",
  projectId: "phoneplay-8d087",
  storageBucket: "phoneplay-8d087.appspot.com",
  messagingSenderId: "663613436513",
  appId: "1:663613436513:web:5d5720d3e1c1acd313b020",
  measurementId: "G-CR0WDJEQS0",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const publicKey =
  "BMK4Z7YhskJAMo8yz3PQOZSbYXAt2SyjThT3BzJeR12gmf_Pxo0KHIXrVTpi5cE48pWFL6dcFiQrn49wo0JUaNs";

// Store last sent token to prevent duplicate API calls
let lastSentToken = null;

export const getFireBaseToken = async (setTokenFound, setNotToken) => {
  let currentToken = "";
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === "granted") {
      currentToken = await getToken(messaging, { vapidKey: publicKey });
      console.log("FCM Permission granted, token:", currentToken);
      
      if (currentToken) {
        setTokenFound(true);
        setNotToken(currentToken);
        
        // Only send token to backend if it's different from the last one
        if (currentToken !== lastSentToken) {
          try {
            await ApiRequest.post(`update_firebase_token`, {
              firebase_token: currentToken,
            });
            lastSentToken = currentToken; // Update last sent token
            console.log("FCM token saved to backend successfully");
          } catch (apiError) {
            console.error("Failed to save FCM token to backend:", apiError);
          }
        } else {
          console.log("FCM token unchanged, skipping backend update");
        }
      } else {
        setTokenFound(false);
        console.warn("No FCM registration token available. Request permission to generate one.");
      }
    } else if (permission === "denied") {
      setTokenFound(false);
      setNotToken(null); // ✅ Call callback even when denied
      console.warn("Notification permission denied by user");
    } else {
      setTokenFound(false);
      setNotToken(null); // ✅ Call callback for other permission states
      console.log("Notification permission not granted:", permission);
    }
  } catch (err) {
    setTokenFound(false);
    setNotToken(null); // ✅ Call callback even on error
    console.error("Error occurred while retrieving FCM token:", err);
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

/**
 * Reset the last sent token (call on logout)
 * This ensures a fresh token is sent on next login
 */
export const resetFirebaseToken = () => {
  lastSentToken = null;
  console.log('Firebase token reset - will send fresh token on next login');
};
